module.exports = __webpack_public_path__ + "static/img/アセット 64@3x.3137a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 64@3x.png
// module id = TbVL
// module chunks = 1